import PropTypes from 'prop-types';
import Text from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';
import Span from '@/components/component-library/Span';

const EpisodeMenuOption = ({
  text,
  onClick,
  icon,
  disabled
}) => {
  return (
    <Text
      bold
      className={ classes('episode-menu-option', { '--is-disabled': disabled }) }
      fixed
      onClick={ onClick } useHeaderFont
    >
      <Span className='icon-wrapper'>
        { icon }
      </Span>
      { text }
    </Text>
  );
};

EpisodeMenuOption.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.node.isRequired,
  disabled: PropTypes.bool
};

EpisodeMenuOption.defaultProps = {
  onClick: undefined,
  disabled: false
};

export default EpisodeMenuOption;